export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-15 md:opacity-20">
        <div className="absolute top-20 right-10 w-64 h-64 rounded-full bg-primary-400/30 blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-96 h-96 rounded-full bg-accent-400/20 blur-3xl"></div>
        <div className="absolute top-40 right-60 w-48 h-48 rounded-full bg-primary-300/25 blur-3xl"></div>
      </div>

      <div className="section-container w-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>蜜桃 · 樱花 · 香蕉 · 红桃视频聚合</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-heading font-bold text-foreground-950 leading-tight">
              宅男视频
              <span className="block text-primary-600 text-2xl sm:text-3xl md:text-4xl lg:text-[2.4rem] mt-2 font-normal">
                专属视频聚合平台
              </span>
            </h1>

            <p className="text-xl sm:text-2xl md:text-3xl font-heading text-foreground-500 mt-4 mb-6">
              海量精选，一站畅享
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 space-y-3">
              <p>
                宅男视频品牌聚合香蕉视频、红桃视频、蜜桃视频、樱花视频等热门平台，
                为你提供宅男专属的高清免费在线观看体验。无论是热门影视、经典合集还是独家精选，
                这里都能满足你的观影需求。每日更新海量内容，专为追求品质的男性用户量身打造。
              </p>
              <p>
                当前热播专题覆盖动作大片、悬疑烧脑剧、搞笑综艺与午夜影院，
                香蕉视频与蜜桃视频双榜同步更新，不错过任何一部好片。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-video-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium">每日更新 2000+ 视频</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-group-line text-primary-500 text-lg"></i>
                <span className="text-sm font-medium">千万宅男信赖之选</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span className="text-sm font-medium">安全流畅 无广告弹窗</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center text-sm"
              >
                <i className="ri-fire-fill mr-2"></i>
                查看热门榜单
              </a>
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                浏览精选视频
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end pt-0 lg:pt-20">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-200/40 rounded-2xl -rotate-12"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent-200/30 rounded-2xl rotate-12"></div>
              <div className="relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <div className="aspect-[4/3] bg-gradient-to-br from-foreground-800 via-foreground-700 to-foreground-900 flex items-center justify-center relative overflow-hidden">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/10 flex items-center justify-center backdrop-blur-sm cursor-pointer hover:bg-white/20 transition-colors">
                      <i className="ri-play-fill text-white text-3xl md:text-4xl ml-1"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 left-4 right-4">
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded whitespace-nowrap">热播中</span>
                      <span className="text-white/80 text-xs">宅男视频 · 高清专区</span>
                    </div>
                  </div>
                </div>
                <div className="p-4 space-y-2">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-movie-line text-primary-600 text-lg"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-foreground-900 truncate">最新上架 · 动作大片合集</p>
                      <p className="text-xs text-foreground-500">今日更新 168 部</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-tv-line text-accent-600 text-lg"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-foreground-900 truncate">热门连载 · 追剧不停</p>
                      <p className="text-xs text-foreground-500">全季同步更新中</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-live-line text-secondary-600 text-lg"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-foreground-900 truncate">午夜专场 · 限时开放</p>
                      <p className="text-xs text-foreground-500">每晚 22:00 准时更新</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}